const primaryColor = '#84bd00';
const secondaryColor = '#222222';
const bonusColor = '#2e7d32'; // Green for time bonuses earned

const config = {
    muiTheme: {
        palette: {
            primary: {
                main: primaryColor,
            },
            secondary: {
                main: secondaryColor
            },
            background: {
                default: '#fafafa',
            }
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: (themeParam) => ({
                    a: {
                        color: primaryColor,
                        textDecoration: 'none',
                    },
                    'a:hover': {
                        textDecoration: 'underline'
                    }
                })
            }
        }
    }
};

export default config;
export { bonusColor };
